import { Router, RouteData, NavigationRoute } from 'shared-utils';
import { getYearRouteParam } from 'utils/yearStore';
import InspectionScreen from './InspectionScreen';

export const InspectionNavigation = (): NavigationRoute => new NavigationRoute(
    InspectionScreen.key,
    [getYearRouteParam()]
);

const router = new Router();

router
    .add(new RouteData({
        key: InspectionScreen.key,
        path: '',
        component: InspectionScreen,
        exact: true,
        metadata: {
            authRequired: true,
            rolesAllowed: ['administrator', 'supervisor', 'writer']
        }
    }));

export default router;